"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = /*#__PURE__*/(0, _react.createContext)({});

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian/select/context.js
// module id = 417
// module chunks = 0